import React from "react";
import Zoom from "react-reveal/Zoom";

const ProjectCard = ({ link, imgSrc, title }) => {
  return (
    <>
      <a href={link} target="_blank">
        <Zoom up>
          <img
            src={imgSrc}
            className="rounded h-full w-full object-cover"
            alt={title}
          />
        </Zoom>
      </a>
    </>
  );
};

export default ProjectCard;
